var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentoAFirmarCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.04,
    height: 34.33,
    viewBox: "0 0 30.04 34.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #316094;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1878",
    "data-name": "Rect\\xE1ngulo 1878",
    className: "cls-1",
    width: 30.04,
    height: 34.33
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pictograma_-_Documentos_a_Firmar_Estado_con_cursor_encima_",
    "data-name": "Pictograma - Documentos a Firmar (Estado con cursor encima)",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4504",
    "data-name": "Trazado 4504",
    className: "cls-3",
    d: "M21.07,4.29A6.113,6.113,0,0,0,19.8,2.15l-.01-.01a4.172,4.172,0,0,0-.47-.47l-.009-.01A6.306,6.306,0,0,0,17.17.38,6.061,6.061,0,0,0,15.03,0h-.02a6.485,6.485,0,0,0-4.27,1.63l-.01.01a3.936,3.936,0,0,0-.5.5l-.01.01A6.113,6.113,0,0,0,8.95,4.29H.01V34.33H30.04V4.29Zm-6.17,0a.375.375,0,0,1,.11-.01h.02a.274.274,0,0,1,.09.01,1.6,1.6,0,0,1,1.5,1.6,1.47,1.47,0,0,1-.1.55A1.609,1.609,0,0,1,15.03,7.5h-.02a1.583,1.583,0,0,1-1.5-1.06,1.451,1.451,0,0,1-.1-.55,1.592,1.592,0,0,1,1.49-1.6m4.42,21.46H6.44V23.6H19.311v.01h.009Zm4.29-6.43H6.44V17.17H23.61Zm0-6.44H6.44V10.73H23.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1875",
    "data-name": "Rect\\xE1ngulo 1875",
    className: "cls-4",
    width: 12.87,
    height: 2.15,
    transform: "translate(6.441 23.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1876",
    "data-name": "Rect\\xE1ngulo 1876",
    className: "cls-4",
    width: 17.17,
    height: 2.14,
    transform: "translate(6.44 17.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1877",
    "data-name": "Rect\\xE1ngulo 1877",
    className: "cls-4",
    width: 17.17,
    height: 2.14,
    transform: "translate(6.44 10.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4505",
    "data-name": "Trazado 4505",
    className: "cls-4",
    d: "M16.62,5.89a1.451,1.451,0,0,1-.1.55A1.606,1.606,0,0,1,15.03,7.5h-.02a1.582,1.582,0,0,1-1.5-1.06,1.451,1.451,0,0,1-.1-.55,1.591,1.591,0,0,1,1.49-1.6.375.375,0,0,1,.11-.01h.02a.277.277,0,0,1,.09.01,1.6,1.6,0,0,1,1.5,1.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentoAFirmarCursor);
export default __webpack_public_path__ + "static/media/documentoAFirmarCursor.302ff9ecda8f9cccb8382e85436bd84d.svg";
export { ForwardRef as ReactComponent };